export function mapGroupPortfolioAnalyses(groupsPortfolioAnalyses) {
  const list = Object
    .values(groupsPortfolioAnalyses)
    .reduce((groupsWithDocs, currentGroup) => {
      const { analysesData } = currentGroup || {};
      if (analysesData && analysesData.length) {
        groupsWithDocs.push(currentGroup);
      }

      return groupsWithDocs;
    }, []);

  return list
    .sort((ga, gb) => {
      const nameA = ga.group.name;
      const nameB = gb.group.name;

      return nameA.localeCompare(nameB);
    });
}
